import { gql } from "@apollo/client";

export const DELETE_VEHICLE_DOCUMENT = gql`
  mutation deleteVehicleDocument($vehicleId: String!, $documentUrl: String!){
    deleteVehicleDocument(vehicleId: $vehicleId, documentUrl: $documentUrl){
    	success
    	message
  	}
	}
` 